import { toast } from 'react-toastify'

export function errorAlert(err) {
    if (err?.response && err?.response?.data && err?.response?.data?.data) {
        return Object.values(err?.response?.data?.data).forEach(errmsg => toast.error(errmsg[0]))
    }else{
        return toast.error(err?.response?.data?.message)
    }
}
